module.exports = __webpack_public_path__ + "static/media/SST AEROP.ffa1a329.png";